
import $ from 'jquery';

function setQuickviewEmailHandler() {


    $('#quickviewCloseButton').click(function () {
        var href = $('.logout_link').attr('href');
        window.location.href = href;
    });

    $('#quickview_email').on('keydown', function (ev) {
        if (13 === ev.keyCode) {
            $('#quickview_email_button').click();
            return false;
        }
    });
}


$(document).ready(function () {

    setQuickviewEmailHandler();
});

